import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { getTalentDetail } from '../../../../services/MyProfile'
import Wrapper from '../../../../components/Wrapper/Wrapper'
import Badge from '../../../../components/Badge/Badge'
import {
  IS_ADMIN,
  NOT_AVAILABLE,
  OUT_OF_THE_APP,
  VIEWPORT_LG,
} from '../../../../utils/constants'
import Button from '../../../../components/Button'
import { copyClipboard, handleOpenModal, openNewTab } from '../../../../utils'
import { CALENDLY_API_URL } from '../../../../services/constants'
import { shareIcon } from '../../ListOfVideoTalents/components/VideoTalentCard/VideoTalentCard'
import Toast from '../../../../components/Toast/Toast'
import { useTranslation } from 'react-i18next'
import DashboardWrapper from '../../../Dashboard/components/DashboardWrapper'
import useResize from '../../../../hooks/useResize'
import CountMaster from '../../../../components/Count/CountMaster'
import EyeIcon from '../../../../icons/EyeIcon'
import HeartIcon from '../../../../icons/HeartIcon'
import ArrowRightIcon from '../../../../icons/ArrowRightIcon'
import StarRatingModal from '../../StarRatingModal/StarRatingModal'

const PublicTalentDetail = () => {
  const { id: talentId } = useParams()
  const { t } = useTranslation()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const { data: talentData = {}, isInitialLoading: isInitialLoadingTalent } =
    useQuery(['hutrit-video-talent-detail', talentId], () =>
      getTalentDetail(talentId)
    )

  const handleShareTalent = () => {
    Toast({ title: '¡talento copiado correctamente!' })
    copyClipboard(
      `${window.location.origin}/hutrit-club-talent-detail/${talentId}`
    )
  }

  const renderSkills = (
    <div className="overflow-auto mt-2 tm-talent-container gap-2">
      {talentData?.talen_skills?.map(({ skills_categori, id }) => (
        <Badge
          key={id}
          className="border border-on-bg-CTA-primary-selected text-on-bg-CTA-primary-selected rounded-pill me-2 font-small-3"
        >
          {skills_categori?.skill?.name || NOT_AVAILABLE}
        </Badge>
      ))}
    </div>
  )

  if (isInitialLoadingTalent) return <>CARGANDO...</>

  return OUT_OF_THE_APP ? (
    <Wrapper activeFooter={false} staticNavbar renderGreen={false}>
      <div className={`${isMobile ? 'px-3' : 'px120'} pt-4`}>
        <div className="rounded border border-on-bg-Tertiary-pressed px40 py-4">
          <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between gap-lg-0 gap-4">
            <div>
              <div>{talentData?.category_job?.name}</div>
              {renderSkills}
            </div>
            <div className="d-flex align-items-center gap-3">
              <Button
                className="btn-bg-white text-on-bg-primary border border-on-bg-primary"
                onClick={handleShareTalent}
              >
                {shareIcon}
              </Button>
              <Button onClick={() => openNewTab({ url: CALENDLY_API_URL })}>
                {t('contact')}
              </Button>
            </div>
          </div>
          <div className="shadow-sm rounded px-2 py-3 mt-4 mb-4">
            <div className="fontSize14 text-center fw-bolder text-on-bg-primary">
              Descripción del reto
            </div>
            <div className="fontSize12 text-on-bg-secondary">
              {talentData?.hutrit_next_videos?.[0]?.description}
            </div>
          </div>
          <video controls className="rounded mb-3" width="100%" height="400px">
            <source
              src={talentData?.hutrit_next_videos?.[0]?.url}
              type="video/mp4"
            />
            Tu navegador no soporta videos.
          </video>
        </div>
      </div>
    </Wrapper>
  ) : (
    <DashboardWrapper showTitle title="Hutrit Club - detalle del talento">
      <StarRatingModal />
      <div className="px-5 pt-4 pb-4">
        <div className="rounded border border-on-bg-Tertiary-pressed px40 py-4" style={{
          width: '950px'
        }}>
          <div className="d-flex flex-column flex-lg-row align-items-center justify-content-between gap-lg-0 gap-4">
            {IS_ADMIN && (
              <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between w-100 gap-3">
                <CountMaster
                  Icon={() => <EyeIcon width="48px" fill="#004949" />}
                  count={300}
                  title="Total de vistas"
                  isFullWidth
                />
                <CountMaster
                  Icon={() => <HeartIcon width="48px" fill="#004949" />}
                  count={4.3}
                  title="Puntuación promedio"
                  isFullWidth
                  renderMoreJsx={
                    <div
                      className="d-flex align-items-center gap-1 pl-3 cursor-pointer"
                      onClick={() => {
                        handleOpenModal({ id: 'star-rating-modal' })
                      }}
                    >
                      <span className="text-decoration-underline text-on-bg-primary fontSize12">
                        Ver puntuaciones
                      </span>
                      <ArrowRightIcon fill="#004949" width="14px" />
                    </div>
                  }
                />
              </div>
            )}
            {!IS_ADMIN && (
              <div>
                <div>{talentData?.category_job?.name}</div>
                {renderSkills}
              </div>
            )}
            {!IS_ADMIN && (
              <div className="d-flex align-items-center gap-3">
                <Button
                  className="btn-bg-white text-on-bg-primary border border-on-bg-primary"
                  onClick={handleShareTalent}
                >
                  {shareIcon}
                </Button>
                <Button onClick={() => openNewTab({ url: CALENDLY_API_URL })}>
                  {t('contact')}
                </Button>
              </div>
            )}
          </div>
          <div className="shadow-sm rounded px-2 py-3 mt-4 mb-4">
            <div className="fontSize14 text-center fw-bolder text-on-bg-primary">
              Descripción del reto
            </div>
            <div className="fontSize12 text-on-bg-secondary">
              {talentData?.hutrit_next_videos?.[0]?.description}
            </div>
          </div>
          <video controls className="rounded mb-3" width="100%" height="400px">
            <source
              src={talentData?.hutrit_next_videos?.[0]?.url}
              type="video/mp4"
            />
            Tu navegador no soporta videos.
          </video>
        </div>
      </div>
    </DashboardWrapper>
  )
}

export default PublicTalentDetail
